import {
    getDataWithParams,
    destroyData,
    downloadFile,
    getAllData,
    postData
} from '@/store/api/method-mbkm'

const itemInit = {
    id: null,
    topic: null,
    link: null,
    date: null,
    dateTemp: null,
    rejectionNote: null,
    room: null,
    study_sessions_id: null,
    status: 1,
    tempStatus: 1,
    inputType: null,
    study_session_room: {},
    sesi: {}
}

const requestInit = {
    page: 1,
    show: 10,
    sortBy: "created_at",
    sorting: "DESC",
    search: null,
    filter: null
}
const initialState = () => ({
    data: {last_page: 0, data: [], total: 0},
    detail: {},
    msg: "Jaringan Bermasalah",
    status: 0,
    request: {...requestInit},
    item: {...itemInit},
    examStatus: [
        {
            class: "warning",
            value: "Menunggu verifikasi dospemb",
            status: 0
        },
        {
            class: "secondary",
            value: "Menunggu verifikasi prodi",
            status: 1
        },
        {
            class: "primary",
            value: "Menunggu verifikasi TU",
            status: 2
        },
        {
            class: "success",
            value: "Pendaftaran Selesai",
            status: 3
        },
        {
            class: "error",
            value: "Pendaftaran ujian ditolak",
            status: 91
        },
        {
            class: "error",
            value: "Menunggu Revisi",
            status: 92
        },
        {
            class: "error",
            value: "Ditolak oleh TU",
            status: 93
        },
        {
            class: "error",
            value: "Mahasiswa Tidak Hadir",
            status: 100
        },
        {
            class: "error",
            value: "Mahasiswa Tidak Lulus",
            status: 101
        },
    ],
    chat: [],
    blobData: null,
})

const state = initialState

const getters = {
    getData: state => state.data || {last_page: 0, data: [], total: 0},
    getRequest: state => state.request,
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getItem: state => state.item,
    getAllStatus: state => state.examStatus,
    getExamStatus: state => (status) => state.examStatus.find(x => x.status == status),
    getBlobData: state => state.blobData,
    getDetail: state => state.detail,
    getChat: state => state.chat || [],
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = '0'
    },
    SET_MSG_FAILED(state, err) {
        if (err.status == 400) {
            state.msg = err.data.msg
            state.status = err.data.status
        } else {
            state.msg = 'Jaringan Bermasalah'
            state.status = '0'
        }
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_DATA(state, value) {
        state.data = value
    },
    SET_REQUEST(state, value) {
        state.request = value
    },
    SET_ITEM(state, value) {
        state.item = value
    },
    SET_DETAIL(state, value) {
        state.detail = value
    },
    SET_CHAT(state, value) {
        state.chat = value
    },
    SET_BLOBDATA(state, {value, type}) {
        state.blobData = new Blob([value], { type: type })
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

const actions = {
    setRequest({commit}, value){
        commit('SET_REQUEST',value)
    },
    resetRequest({commit}){
        commit('SET_REQUEST', {...requestInit})
    },
    setItem({commit}, value){
        commit('SET_ITEM',value)
    },
    resetItem({commit}){
        commit('SET_ITEM', {...itemInit})
    },
    async getAllMahasiswaExam({commit, state}) {
        try {
            const response = await getDataWithParams('/entrepreneurship-exam', state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getDetailKewir({commit }, id) {
        try {
            const url = `/entrepreneurship/detail/${id}`
            const response = await getAllData(url)
            commit('SET_RESPONSE', response.data)
            commit('SET_DETAIL', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getAllExam({commit, state}, id) {
        try {
            const url = `/entrepreneurship-exam/${id}`
            const response = await getDataWithParams(url, state.request)
            commit('SET_RESPONSE', response.data)
            commit('SET_DATA', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async postExam({commit }, {id, data}) {
        try {
            const url = `/entrepreneurship-exam/${id}`
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async updateExam({commit }, data) {
        try {
            const url = `/entrepreneurship-exam/update/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async verifyExam({commit }, {data, role}) {
        try {
            const url = `/entrepreneurship-exam/verify/${role}/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async deleteExam({commit }, data) {
        try {
            const url = `/entrepreneurship-exam/${data.id}`
            const response = await destroyData(url)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async getAllExamChat({commit }, id) {
        try {
            const url = `/entrepreneurship-exam/chat/${id}`
            const response = await getAllData(url)
            commit('SET_RESPONSE', response.data)
            commit('SET_CHAT', response.data.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async postExamChat({commit }, {message, id}) {
        try {
            const url = `/entrepreneurship-exam/chat/${id}`
            const response = await postData(url, {message})
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async notPresent({commit }, id) {
        try {
            const url = `/entrepreneurship-exam/notpresent/${id}`
            const response = await postData(url)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async notPassed({commit }, id) {
        try {
            const url = `/entrepreneurship-exam/notpassed/${id}`
            const response = await postData(url)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async confirmResult({commit }, {id, data}) {
        try {
            const url = `/entrepreneurship-exam/confirmation-lecture/${id}`
            const response = await postData(url, data)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async confirmAdmin({commit }, data) {
        try {
            const url = `/entrepreneurship-exam/confirmation-admin/${data.detail_id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData(url, payload)
            commit('SET_RESPONSE', response.data)
        } catch (e) {
            if (e.response) {
                commit('SET_MSG_FAILED', e.response)
            } else {
                commit('SET_FAILED')
            }
        }
    },
    async downloadBeritaAcara({commit }, {data, type}) 
    {
        try {
            const url = `/entrepreneurship/berita-acara/${data.detail_id}`
            const payload = {
                ...data
            }
            delete payload.id
            var response = await downloadFile(url);
            commit('SET_BLOBDATA', {value: response.data,type: type});
        } catch (e) {
            if(e.response){
                commit('SET_FAILED_MESSAGE',e.response)
            }else{
                commit('SET_FAILED')
            }
        }
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}